import React, { useState } from "react";
import { Popover, Box, Typography, Button } from "@mui/material";
import GradeSelector from "./GradeSelector";

const GradeSelectorPopover = ({
  anchorEl,
  open,
  onClose,
  onGradeSelect,
  currentGrade,
  rubricName,
  setGrade,
}) => {
  const [selectedGrade, setSelectedGrade] = useState(currentGrade || "åk9");

  const handleGradeSelect = () => {
    setGrade(selectedGrade);
    onGradeSelect(selectedGrade);
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      PaperProps={{
        sx: {
          p: 3,
          width: 320,
          borderRadius: 2,
          boxShadow:
            "0 26px 58px 0 rgba(0, 0, 0, .22), 0 5px 14px 0 rgba(0, 0, 0, .18) !important",
        },
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Välj årskurs för matrisen
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, display: "none" }}
        >
          ({rubricName})
        </Typography>

        <Box sx={{ mb: 3 }}>
          <GradeSelector
            grade={selectedGrade}
            setGrade={setSelectedGrade}
            hideSome={true}
            whiteVariant={true}
          />
        </Box>

        <Button variant="purp" fullWidth onClick={handleGradeSelect}>
          Välj och fortsätt
        </Button>
      </Box>
    </Popover>
  );
};

export default GradeSelectorPopover;
